import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { ClinicDataProvider } from "./context/ClinicDataContext";
import ProtectedRoute, { isAuthenticated } from "./components/ProtectedRoute";
import AppLayout, { BASE_PATH } from "./components/AppLayout/AppLayout";
import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import AppointmentsPage from "./pages/Appointments/AppointmentsPage";
import CheckoutPage from "./pages/Checkout/CheckoutPage";
import PatientsPage from "./pages/Patients/PatientsPage";
import PatientDetailPage from "./pages/PatientDetail/PatientDetailPage";
import TreatmentsPage from "./pages/Treatments/TreatmentsPage";
import DentistsPage from "./pages/Dentists/DentistsPage";
import BillingPage from "./pages/Billing/BillingPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import { FEATURES } from "./config/features";

const Fallback = () => <Navigate to={isAuthenticated() ? BASE_PATH : "/login"} replace />;

function App() {
  return (
    <ClinicDataProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path={BASE_PATH}
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="patients" element={<PatientsPage />} />
            <Route path="patients/:patientId" element={<PatientDetailPage />} />
            <Route path="treatments" element={<TreatmentsPage />} />
            <Route path="dentists" element={<DentistsPage />} />
            <Route path="billing" element={FEATURES.billing ? <BillingPage /> : <Navigate to={BASE_PATH} replace />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<Fallback />} />
        </Routes>
      </Router>
    </ClinicDataProvider>
  );
}

export default App;
